import React from 'react';
import {Navigate, useRoutes} from 'react-router-dom';
import {DEFAULT_PATH} from 'apps/dashboard/ConfigGlobal';
import {LoadingScreen} from 'packages/common/components/loading-screen';
import {useAuthContext} from 'packages/common/hooks';
import {paths} from 'packages/common/routes/paths';
import {mainRoutes} from './Main';
import {authRoutes} from './Auth';
import {appRoutes} from './App';
import {adminRoutes} from './Admin';
import {ExploreRedirect} from './ExploreRedirect';

const RootRedirect = () => {
  const {isAuthenticated, userRole, loading} = useAuthContext();

  // Afficher un loader pendant la vérification de l'authentification
  if (loading) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    return <Navigate to={DEFAULT_PATH} replace />;
  }

  if (userRole === 'AppAdmin') {
    return <Navigate to={paths.admin.root} replace />;
  }

  return <Navigate to={paths.app.root} replace />;
};

export default function Router() {
  return useRoutes([
    {
      path: '/',
      element: <RootRedirect />,
    },

    // Redirection des anciennes URLs /explore
    {
      path: '/explore/:slug',
      element: <ExploreRedirect />,
    },

    // Auth routes
    ...authRoutes,

    // Dashboard User routes
    ...appRoutes,

    // Dashboard Admin routes
    ...adminRoutes,

    // Main routes
    ...mainRoutes,

    // No match 404
    {path: '*', element: <Navigate to="/404" replace />},
  ]);
}
